import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    AppBar, Box, Toolbar, Typography, Button, IconButton, Avatar, Menu, MenuItem, Tooltip, Divider
} from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GavelIcon from '@mui/icons-material/Gavel';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';

function SiteHeader() {
    const { user, logout, isGlobalAdmin } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleLogout = () => {
        handleClose();
        logout();
        navigate('/');
    };

    return (
        <AppBar position="static">
            <Toolbar>
                <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center', color: 'inherit', textDecoration: 'none' }}>
                    <img src="/logo192.png" alt="Spelveilingen logo" style={{ height: '60px', marginRight: '5px' }} />
                    <Typography 
                        variant="h6" 
                        component="div"
                    >
                        Spelveilingen
                    </Typography>
                </Box>
                <Box sx={{ flexGrow: 1 }} />

                {user ? (
                    <Box>
                        <Tooltip title="Account instellingen">
                            <IconButton onClick={handleMenu} sx={{ p: 0 }}>
                                <Avatar>{(user.name || user.email || '').charAt(0).toUpperCase()}</Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                            <MenuItem onClick={() => { navigate('/my-auctions'); handleClose(); }}>
                                <GavelIcon sx={{ mr: 1 }} />
                                Mijn Veilingen
                            </MenuItem>
                            <MenuItem onClick={() => { navigate('/ranglijst-aller-tijden'); handleClose(); }}>
                                <LeaderboardIcon sx={{ mr: 1 }} />
                                Ranglijst aller tijden
                            </MenuItem>
                            <MenuItem onClick={() => { navigate('/prijzenkast'); handleClose(); }}>
                                <EmojiEventsIcon sx={{ mr: 1 }} />
                                Prijzenkast
                            </MenuItem>
                            <MenuItem onClick={() => { navigate('/account'); handleClose(); }}>
                                <AccountCircleIcon sx={{ mr: 1 }} />
                                Account
                            </MenuItem>
                            {isGlobalAdmin && <Divider />}
                            {isGlobalAdmin && (
                                <MenuItem onClick={() => { navigate('/admin'); handleClose(); }}>
                                    <AdminPanelSettingsIcon sx={{ mr: 1 }} />
                                    Administrator
                                </MenuItem>
                            )}
                            <Divider />
                            <MenuItem onClick={handleLogout}>
                                <LogoutIcon sx={{ mr: 1 }} />
                                Uitloggen
                            </MenuItem>
                        </Menu>
                    </Box>
                ) : (
                    <Button color="inherit" component={RouterLink} to="/login">
                        Inloggen
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    );
}

export default SiteHeader;